export default __webpack_public_path__ + "static/char-v-46-ja-2cdee8ffe2a29050fc40763883038642.mp4";